// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Subscriber[data-v-1a1d6c41] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
